/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Reset_ButtonInputs */



/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Explorer_Search_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_reset_button = /** @type {((inputs?: Explorer_Search_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reset")
	return /** @type {LocalizedString} */ ("Reset")
});